import React, { Component } from 'react';
import PageTreeCB from '~/components/CheckBox/PageTreeCB';
import PageTreeNode from '~/components/CheckBox/PageTreeNode';
import Second from './Second';
export default class First extends Component {
  state={ display: false }
  render () {
    const { data = {}, value = [], onChange, disabled = false } = this.props;
    const { display } = this.state;
    const { list = [] } = data;
    let haveActionList = false;
    const haveList = list.length > 0;
    for (const o of list) if (o.type === 'ACTION')haveActionList = true;
    let isAllCheck = true;
    let isAllDisCheck = true;
    const handleLists = (l = [], func = () => {}) => {
      for (const o of l) {
        func((o || {}));
        if (((o || {}).list || []).length > 0) { handleLists(o.list, func); }
      }
    };
    handleLists(list, o => {
      if (value.indexOf(o.id) === -1) isAllCheck = false;
      else isAllDisCheck = false;
    });

    const clickAll = () => {
      const ary = [];
      handleLists(list, o => {
        if (isAllCheck || (value.indexOf(o.id) === -1)) ary.push(o.id);
      });
      onChange(ary);
    };
    return (
      <div style={{ display: 'flex', position: 'relative', flexDirection: 'column' }}>
        <div style={{ display: 'flex' }}>
          <div style={{ height: 5, width: haveList ? 20 : 40, backgroundColor: 'black', marginTop: 9 }} />
          {haveList && <PageTreeNode value={display} onClick={() => this.setState({ display: !display })} />}
          {haveList && <div style={{ width: 5 }} />}
          {haveList && !haveActionList && <PageTreeCB disabled={disabled} value={!isAllDisCheck} isLine={!isAllCheck} onClick={haveActionList ? () => onChange([data.id]) : clickAll} />}
          {(!haveList || haveActionList) && <PageTreeCB disabled={disabled} value={value.indexOf(data.id) > -1} onClick={() => onChange([data.id])} />}
          <div style={{ fontSize: 16, marginLeft: 5 }}>{data.name}</div>
        </div>
        {display && list.map((o, i) => <Second disabled={disabled} key={i} data={o} isBottom={list.length === i + 1} value={value} onChange={onChange} />)}
        <div style={{ height: 5 }} />
        <div style={{ position: 'absolute', width: 5, height: '100%', backgroundColor: 'black' }} />
      </div>
    );
  }
}
